import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  CuiButtonModule,
  CuiHeaderModule,
  CuiInputModule,
  CuiLoaderModule,
  CuiSidebarModule,
  CuiSpinnerModule,
  CuiTableModule,
  CuiToastModule,
} from '@cisco-ngx/cui-components';

@NgModule({
  imports: [
    CommonModule,

    CuiButtonModule,
    CuiHeaderModule,
    CuiInputModule,
    CuiLoaderModule,
    CuiSidebarModule,
    CuiSpinnerModule,
    CuiTableModule,
    CuiToastModule,
  ],
  exports: [
    CuiButtonModule,
    CuiHeaderModule,
    CuiInputModule,
    CuiLoaderModule,
    CuiSidebarModule,
    CuiSpinnerModule,
    CuiTableModule,
    CuiToastModule,
  ]
})
export class CiscoUiModule { }
